import httpService from "app/services/httpService";
import config from "../../../../src/config.json";

const apiUrl = config.apiUrl;

const getBookingHistory = async (query) => {
  const url = `${apiUrl}/flight/book-flight-all${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};
const getBookingHistoryByDist = async (query) => {
  const url = `${apiUrl}/flight/dist-book-flight-all${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const holdGetBookingHistory = async (query) => {
  const url = `${apiUrl}/flight/hold-book-flight-all${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const bookingDetails = async (id) => {
  //debugger;
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/booking-details/${id}`,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

const changeRequestDetails = async (query) => {
  const url = `${apiUrl}/flight/booked-flight-change-request-list${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};

const approveRequestDetails = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/approve-booking-request`,
      values,
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const declineRequestDetails = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/decline-booking-request`,
      values,
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const internationalTicketHandler = async (id, withPrice) => {
  try {
    const url = `${apiUrl}/flight/print-ticket/${id}?withPrice=` + withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const ticketHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/tripjack-print-ticket/${bookingId}?withPrice=` +
      withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const offlineTicketHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/admin-print-ticket/${bookingId}?withPrice=` + withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const refundInvoiceHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/tripjack-print-refund-invoice/${bookingId}?withPrice=` +
      withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const exportBookedFlight = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/book-flight-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const exportBookedFlightByDist = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/dist-book-flight-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const HoldExportBookedFlight = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/hold-book-flight-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const sendTicketInEmail = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/ticket/sendemail/${values}`,
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const cancelTicketRequested = async (values) => {
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/approve-cancellation-booking-request`,
      values,
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getCancellationList = async (query) => {
  const url = `${apiUrl}/flight/cencelled-flight-list${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const exportCancellationList = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/cancellation-flight-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getBookingDetails = async (id) => {
  // debugger;
  try {
    const data = await httpService.get(`${apiUrl}/flight/booked-flight/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const getFlightMarkup = async (id) => {
  // debugger;
  try {
    const data = await httpService.get(
      `${apiUrl}/flightcarrier/active-carrier-commission`,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const insuranceType = async (id) => {
  // debugger;
  try {
    const data = await httpService.post(`${apiUrl}/mihuru/insurance-type`);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const insurance = async (values) => {
  try {
    const data = await httpService.post(`${apiUrl}/mihuru/insurance`, values);
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const refundCancellationAmount = async (values) => {
  // debugger;
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/refund-cancelled-amount`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

const updateBillNo = async (values) => {
  // debugger;
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/update-billno`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const updateIssueDateTime = async (values) => {
  // debugger;
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/flight-issue-date-update`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const uploadOriginalTicket = async (values) => {
  // debugger;
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/upload-ticket`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};


const printUploadedOriginalTicket = async (values) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/flight/download-ticket/${values}`,
      {
        responseType: "blob", // ✅ CRITICAL FIX
      }
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
export {
  printUploadedOriginalTicket,
  uploadOriginalTicket,
  updateIssueDateTime,
  updateBillNo,
  refundCancellationAmount,
  exportBookedFlightByDist,
  getBookingHistoryByDist,
  HoldExportBookedFlight,
  holdGetBookingHistory,
  getCancellationList,
  exportCancellationList,
  getBookingHistory,
  bookingDetails,
  changeRequestDetails,
  approveRequestDetails,
  declineRequestDetails,
  internationalTicketHandler,
  ticketHandler,
  exportBookedFlight,
  sendTicketInEmail,
  cancelTicketRequested,
  getBookingDetails,
  getFlightMarkup,
  offlineTicketHandler,
  insuranceType,
  insurance,
  refundInvoiceHandler,
};
